// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_form__CUfJW .styles_wrapper__fBTgV {
  display: flex;
  align-items: center;
  padding: 40px;
  flex-direction: column;
  justify-content: center;
  position: relative;
  width: 500px;
}
.styles_form__CUfJW .styles_header__Roze2,
.styles_form__CUfJW .styles_body__JNkAp,
.styles_form__CUfJW .styles_actions__CY1aP {
  width: 100%;
  padding: 0;
}
.styles_form__CUfJW .styles_body__JNkAp,
.styles_form__CUfJW .styles_actions__CY1aP {
  margin-top: 32px;
}
.styles_form__CUfJW .styles_body__JNkAp div,
.styles_form__CUfJW .styles_actions__CY1aP div {
  width: 100%;
}
.styles_form__CUfJW .styles_body__JNkAp {
  overflow: unset;
}
.styles_form__CUfJW .styles_close__NfIMo {
  position: absolute;
  width: 24px;
  height: 24px;
  right: 10px;
  top: 10px;
  padding: 0;
}
.styles_form__CUfJW .styles_close__NfIMo .styles_icon__ESwJc {
  width: 100%;
  width: 12px;
  height: 12px;
}
.styles_form__CUfJW .styles_headline__8hlli {
  font-family: "Open Sans Semi Bold";
  font-style: normal;
  font-size: 30px;
  line-height: 116%;
  color: #333333;
  text-align: center;
}
.styles_form__CUfJW .styles_button__uZ60R {
  width: 100%;
  padding-top: 14px;
  padding-bottom: 14px;
  font-family: "Open Sans Semi Bold";
  font-style: normal;
  font-size: 14px;
  line-height: 116%;
  outline: none;
  border: none;
  background: #49a3a6;
  border-radius: 40px;
  color: #ffffff;
  text-transform: none;
}
.styles_form__CUfJW .styles_button__uZ60R:hover {
  background: #49a3a6;
}
.styles_form__CUfJW .styles_inputWrapper__PoA\\+n {
  width: 100%;
}
.styles_form__CUfJW .styles_inputWrapper__PoA\\+n .styles_input__06JfT,
.styles_form__CUfJW .styles_inputWrapper__PoA\\+n .styles_textarea__zcXxS {
  color: rgb(145, 156, 167);
  border: 1px solid rgb(178, 184, 191);
  border-radius: 10px;
}
.styles_form__CUfJW .styles_inputWrapper__PoA\\+n .styles_input__06JfT input {
  height: 50px;
}
.styles_form__CUfJW .styles_inputWrapper__PoA\\+n textarea,
.styles_form__CUfJW .styles_inputWrapper__PoA\\+n input {
  box-sizing: border-box;
  outline: none;
  padding: 12px 13px;
  width: 100%;
  border-radius: 10px;
}
.styles_form__CUfJW .styles_inputWrapper__PoA\\+n textarea:focus,
.styles_form__CUfJW .styles_inputWrapper__PoA\\+n input:focus {
  color: #333333;
  box-shadow: #333333 0 0 0 1px;
}
.styles_form__CUfJW .styles_inputWrapper__PoA\\+n .styles_textarea__zcXxS {
  resize: none;
  font-family: "Open Sans";
  font-style: normal;
  font-size: 16px;
  line-height: 140%;
  color: #919ca7;
}
.styles_form__CUfJW .styles_inputWrapper__PoA\\+n fieldset {
  border: none;
  outline: none;
}
.styles_form__CUfJW .styles_inputWrapper__PoA\\+n .styles_helper__\\+hLce {
  position: absolute;
  bottom: -20px;
  margin-top: 0;
  opacity: 0;
  pointer-events: none;
  margin: 0 14px;
  width: calc(100% - 28px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.styles_form__CUfJW .styles_invalid__MAOBZ .styles_input__06JfT,
.styles_form__CUfJW .styles_invalid__MAOBZ .styles_textarea__zcXxS {
  color: rgb(223, 89, 89);
  border: 1px solid rgb(223, 89, 89);
}
.styles_form__CUfJW .styles_invalid__MAOBZ .styles_input__06JfT input:focus,
.styles_form__CUfJW .styles_invalid__MAOBZ .styles_input__06JfT textarea:focus,
.styles_form__CUfJW .styles_invalid__MAOBZ .styles_textarea__zcXxS input:focus,
.styles_form__CUfJW .styles_invalid__MAOBZ .styles_textarea__zcXxS textarea:focus {
  color: rgb(223, 89, 89);
  box-shadow: rgb(223, 89, 89) 0 0 0 1px;
}
.styles_form__CUfJW .styles_invalid__MAOBZ .styles_helper__\\+hLce {
  opacity: 1;
  pointer-events: initial;
  color: rgb(223, 89, 89);
}`, "",{"version":3,"sources":["webpack://./src/components/FormDialog/styles.module.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;AAAJ;AAEE;;;EAGE,WAAA;EACA,UAAA;AAAJ;AAGE;;EAEE,gBAAA;AADJ;AAGI;;EACE,WAAA;AAAN;AAIE;EACE,eAAA;AAFJ;AAIE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AAFJ;AAII;EACE,WAAA;EACA,WAAA;EACA,YAAA;AAFN;AAME;EACE,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAJJ;AAOE;EACE,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;AALJ;AAOI;EACE,mBAAA;AALN;AASE;EACE,WAAA;AAPJ;AASI;;EAEE,yBAAA;EACA,oCAAA;EACA,mBAAA;AAPN;AAWM;EACE,YAAA;AATR;AAaI;;EAEE,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AAXN;AAaM;;EACE,cAAA;EACA,6BAAA;AAVR;AAcI;EACE,YAAA;EACA,wBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAZN;AAeI;EACE,YAAA;EACA,aAAA;AAbN;AAgBI;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;EACA,cAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAdN;AAmBI;;EAEE,uBAAA;EACA,kCAAA;AAjBN;AAmBM;;;;EAEE,uBAAA;EACA,sCAAA;AAfR;AAmBI;EACE,UAAA;EACA,uBAAA;EACA,uBAAA;AAjBN","sourcesContent":[".form {\n  .wrapper {\n    display: flex;\n    align-items: center;\n    padding: 40px;\n    flex-direction: column;\n    justify-content: center;\n    position: relative;\n    width: 500px;\n  }\n  .header,\n  .body,\n  .actions {\n    width: 100%;\n    padding: 0;\n  }\n\n  .body,\n  .actions {\n    margin-top: 32px;\n\n    div {\n      width: 100%;\n    }\n  }\n\n  .body {\n    overflow: unset;\n  }\n  .close {\n    position: absolute;\n    width: 24px;\n    height: 24px;\n    right: 10px;\n    top: 10px;\n    padding: 0;\n\n    .icon {\n      width: 100%;\n      width: 12px;\n      height: 12px;\n    }\n  }\n\n  .headline {\n    font-family: 'Open Sans Semi Bold';\n    font-style: normal;\n    font-size: 30px;\n    line-height: 116%;\n    color: #333333;\n    text-align: center;\n  }\n\n  .button {\n    width: 100%;\n    padding-top: 14px;\n    padding-bottom: 14px;\n    font-family: 'Open Sans Semi Bold';\n    font-style: normal;\n    font-size: 14px;\n    line-height: 116%;\n    outline: none;\n    border: none;\n    background: #49a3a6;\n    border-radius: 40px;\n    color: #ffffff;\n    text-transform: none;\n\n    &:hover {\n      background: #49a3a6;\n    }\n  }\n\n  .inputWrapper {\n    width: 100%;\n\n    .input,\n    .textarea {\n      color: rgba(145, 156, 167, 1);\n      border: 1px solid rgba(178, 184, 191, 1);\n      border-radius: 10px;\n    }\n\n    .input {\n      input {\n        height: 50px;\n      }\n    }\n\n    textarea,\n    input {\n      box-sizing: border-box;\n      outline: none;\n      padding: 12px 13px;\n      width: 100%;\n      border-radius: 10px;\n\n      &:focus {\n        color: #333333;\n        box-shadow: #333333 0 0 0 1px;\n      }\n    }\n\n    .textarea {\n      resize: none;\n      font-family: 'Open Sans';\n      font-style: normal;\n      font-size: 16px;\n      line-height: 140%;\n      color: #919ca7;\n    }\n\n    fieldset {\n      border: none;\n      outline: none;\n    }\n\n    .helper {\n      position: absolute;\n      bottom: -20px;\n      margin-top: 0;\n      opacity: 0;\n      pointer-events: none;\n      margin: 0 14px;\n      width: calc(100% - 14px * 2);\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n    }\n  }\n\n  .invalid {\n    .input,\n    .textarea {\n      color: rgba(223, 89, 89, 1);\n      border: 1px solid rgba(223, 89, 89, 1);\n\n      input:focus,\n      textarea:focus {\n        color: rgba(223, 89, 89, 1);\n        box-shadow: rgba(223, 89, 89, 1) 0 0 0 1px;\n      }\n    }\n\n    .helper {\n      opacity: 1;\n      pointer-events: initial;\n      color: rgba(223, 89, 89, 1);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `styles_form__CUfJW`,
	"wrapper": `styles_wrapper__fBTgV`,
	"header": `styles_header__Roze2`,
	"body": `styles_body__JNkAp`,
	"actions": `styles_actions__CY1aP`,
	"close": `styles_close__NfIMo`,
	"icon": `styles_icon__ESwJc`,
	"headline": `styles_headline__8hlli`,
	"button": `styles_button__uZ60R`,
	"inputWrapper": `styles_inputWrapper__PoA+n`,
	"input": `styles_input__06JfT`,
	"textarea": `styles_textarea__zcXxS`,
	"helper": `styles_helper__+hLce`,
	"invalid": `styles_invalid__MAOBZ`
};
export default ___CSS_LOADER_EXPORT___;
